import { Box, constants, Image, Stack, Text } from '@redbubble/design-system';
import { useIntl } from '@redbubble/next/intl';
import { messages } from '../../messages';
import { ModelData as ModelProps } from '../../types';
import { getTranslatedMessage } from '../../utils/dataHelpers';

import styles from './Model.module.scss';

export const Model = ({
  imageUrl,
  modelMeasurements,
  modelSize,
}: ModelProps) => {
  const intl = useIntl();

  return (
    <Box className={styles.modelSection}>
      <Box
        display="flex"
        justifyContent="center"
        paddingBottom="s"
        paddingLeft="s"
      >
        <Image src={imageUrl} alt="" width={220} />
      </Box>

      <Stack spacing="m">
        <Stack direction={constants.VERTICAL}>
          <Text type="display5" element="h3">
            {intl.formatMessage(messages.modelSize)}
          </Text>
          <Text type="body2">{getTranslatedMessage(modelSize, intl)}</Text>
        </Stack>

        <Stack>
          <Text type="display5" element="h3">
            {intl.formatMessage(messages.modelMeasurements)}
          </Text>
          {modelMeasurements.map((measurement, i) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: noArrayIndexKey
            <Text type="body2" key={i}>
              {getTranslatedMessage(measurement, intl)}
            </Text>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
};
